// salesOrderViewReducer.js

export const initialState = {
  dateList: [],
  isUserReady: false,
  isUserReadyForPrefillData: false,
  currentUpdate: '',
  isGetAttachment: false,
  showConvertToMo: false,
  showConvertToPr: false,
  showDCDrawer: false,
  currentTab: '/sales-order-lines',
  showReservationDrawer: false,
  showUpdateReservationDrawer: false,
  showNewSalesForm: false,
  visibleColumns: {
    PRODUCT: {
      label: 'SKU#',
      visible: true,
      disabled: true,
    },
    QUANTITY: {
      label: 'Quantity',
      visible: true,
      disabled: true,
    },
    PACKED_QUANTITY: {
      label: 'Packed_quantity',
      visible: true,
      disabled: true,
    },
  },
  documentUINames: {},
  showNewInvoiceForm: false,
  cancellationReason: '',
  currentTenantId: '',
  currentOrderId: '',
  fileList: [],
  updateAccountManager: '',
  selectedTags: [],
  cfSalesOrderLine: [],
  soMapping: {},
  salesOrderType: '',
  cancellationPop: false,
};

export const packingSlipViewReducer = (state, action) => {
  switch (action.type) {
    case 'SET_INITIAL_STATE':
      return {
        ...state,
        documentUINames: action.payload.documentUINames,
        salesOrderType: action.payload.salesOrderType,
      };

    case 'SET_USER_READY_ORDERID_TENANTID':
      return {
        ...state,
        isUserReady: true,
        currentOrderId: action.payload.orderId,
        currentTenantId: action.payload.tenantId,
      };

    case 'SET_IS_USER_READY_FOR_PREFILL_DATA':
      return {
        ...state,
        isUserReadyForPrefillData: action.payload,
      };

    case 'SET_PREFILL_DATA':
      return {
        ...state,
        fileList: action.payload.attachments,
        updateAccountManager: action.payload.accountManagerId,
        selectedTags: action.payload.tags,
        cfSalesOrderLine: action.payload.customFields,
        visibleColumns: action.payload.visibleColumns,
        soMapping: action.payload.mapping,
        isUserReadyForPrefillData: true,
      };

    case 'SET_ATTACHMENT_IS_GET_ATTACHMENT':
      return {
        ...state,
        fileList: action.payload.fileList,
        isGetAttachment: action.payload.isGetAttachment,
      };

    case 'SET_FILE_LIST':
      return {
        ...state,
        fileList: action.payload,
      };

    case 'SET_IS_GET_ATTACHMENT':
      return {
        ...state,
        isGetAttachment: action.payload,
      };

    case 'UPDATE_VISIBLE_COLUMNS':
      return {
        ...state,
        visibleColumns: action.payload,
      };

    case 'SET_CANCELLATION_REASON':
      return {
        ...state,
        cancellationReason: action.payload,
      };

    case 'SET_CURRENT_UPDATE':
      return {
        ...state,
        currentUpdate: action.payload,
      };

    case 'SET_CANCELLATION_POP':
      return {
        ...state,
        cancellationPop: action.payload,
      };

    case 'SET_SHOW_NEW_INVOICE_FORM':
      return {
        ...state,
        showNewInvoiceForm: action.payload,
      };

    case 'SET_VISIBLE_COLUMNS':
      return {
        ...state,
        visibleColumns: action.payload,
      };

    case 'RESET_STATE':
      return initialState;

    default:
      return state;
  }
}
